import type { StatusTone } from "_shared/_views/tables/status-chip";
import { InvitationStatus } from "legal-entities/invitations/statuses/invitation-status";

/**
 * The tone an invitation's status chip takes (#6713). An open invitation waits on the invitee, so it
 * is moving; an accepted one is settled; the rest are over.
 */
export function invitationStatusTone(status: InvitationStatus | null | undefined): StatusTone {
  switch (status) {
    case InvitationStatus.Open:
      return "info";
    case InvitationStatus.Accepted:
      return "success";
    default:
      return "neutral";
  }
}
